import React from 'react';

export interface ISpinnerProps {
  active: boolean;
}

export const Spinner  = (props: ISpinnerProps) => {

  return (
    <>
      { props.active &&
      <div className="spinner">
        <span className="visually-hidden">Loading...</span>
      </div>
      }
    </>
  );
}
